const features_and_bugs_tour = {
	features_bugs_tour_steps: {
		bug_button: {
			description: "Found a bug? Let us know using this button.",
			title: "Found a bug?",
		},
		bug_text: {
			description: "Here you can see bugs found by others.",
			title: "Report text",
		},
		features_button: {
			description: "Here you can make your own feature request.",
			title: "Your own request?",
		},
		features_text: {
			description: "These are requests to improve our website.",
			title: "Requested features",
		},
	},

	features_dialog_tour_steps: {
		description_bug: {
			description: "Here you can write a description to let us know what you want.",
			title: "Give us a description",
		},
		title_bug: {
			description: "Here you can write the title of your request.",
			title: "Title",
		},
		upload_bug: {
			description:
				"Here you can upload a screenshot. Click in the middle and select the file you want to upload.",
			title: "upload",
		},
	},
};
export default features_and_bugs_tour;
